export const DEBOUNCE_TIME = 500;
export const APPLICATION_JSON = 'application/json';
export const CONTENT_TYPE = "Content-Type";
const MULTIPART_FORM = 'multipart/form-data';
export const MULTIPART_FORM_CONFIG = {[CONTENT_TYPE]: MULTIPART_FORM}